<script setup lang="ts">
import { useTemplateRef } from 'vue'
import { useBrxmData } from '../../composables/useBrxmData'
import { ELegalWidth } from './ts/types'
import type { IBrxmProps } from '@/cms-ui/ts/interfaces/IBrxmProps'
import { isDark } from '@/ui/helpers/utils'
import { useVisibilityTracking } from '@/cms-ui/composables/useAnalytics'

const props = defineProps<IBrxmProps>()
const data = useBrxmData(props, 'LEGAL')
const { description, width, darkmode, textAlignment } = data.value
const legalRef = useTemplateRef('legalRef')

useVisibilityTracking(legalRef, 'Legal', 'Legal')

const setWidth = {
    [ELegalWidth.WIDE]: 'lg:col-span-12',
    [ELegalWidth.NARROW]: 'lg:col-span-8 lg:col-start-3',
}
</script>

<template>
    <section
        ref="legalRef"
        class="space-condensed"
    >
        <div class="container">
            <div class="container-grid">
                <div
                    class="col-span-4 md:col-span-10"
                    :class="[isDark(darkmode), setWidth[width as ELegalWidth]]"
                >
                    <div
                        v-html-gpp="description.value"
                        class="text-neutral-secondary paragraph-xs text-left"
                        :class="{ 'lg:text-center': textAlignment === 'CENTER' }"
                    />
                </div>
            </div>
        </div>
    </section>
</template>
